document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-product-tabs]").forEach((root) => {
    const tabs = root.querySelectorAll('[role="tab"]');
    const panels = root.querySelectorAll('[role="tabpanel"]');

    function activate(tab) {
      tabs.forEach(t => {
        const active = t === tab;
        t.classList.toggle("is-active", active);
        t.setAttribute("aria-selected", active ? "true" : "false");
      });

      panels.forEach(p => {
        const shouldShow = p.id === tab.getAttribute("aria-controls");
        p.hidden = !shouldShow;
      });
    }

    tabs.forEach(tab => tab.addEventListener("click", () => activate(tab)));
  });
});
